import { useState } from 'react';

// Fallback editor/preview for any block type not yet present in
// block-editors/registry.js - edits the raw text + config JSON directly.
// BlockCard.jsx uses this until a dedicated per-type editor lands.
export default function GenericBlockEditor({ block, onSave, onCancel }) {
   const [text, setText] = useState(block.text || '');
   const [configText, setConfigText] = useState(block.config || '');

   const handleSave = () => {
      onSave({ text, config: configText });
   };

   return (
      <div className='exercise-block-generic-editor'>
         <textarea className='exercise-block-generic-text' rows={2} value={text}
            placeholder='Текст' onChange={e => setText(e.target.value)} />
         <textarea className='exercise-block-generic-config' rows={3} value={configText}
            placeholder='config (JSON)' onChange={e => setConfigText(e.target.value)} />
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderGenericPreview(block) {
   return (
      <div className='exercise-block-generic-preview'>
         {block.text ? <p>{block.text}</p> : <p className='exercise-block-empty-hint'>Порожньо - натисніть редагувати</p>}
      </div>
   );
}
